import { render } from "./Name.vue?vue&type=template&id=c4a169d6&scoped=true"
import script from "./Name.vue?vue&type=script&lang=js"
export * from "./Name.vue?vue&type=script&lang=js"

import "./Name.vue?vue&type=style&index=0&id=c4a169d6&scoped=true&lang=css"

import exportComponent from "/app/tmp/360pt/V3/v2026.31.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4a169d6"]])

export default __exports__